import { Inject, Injectable } from "@angular/core";
import { DwDataRequest, DwDatasource, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwQuery, DwQueryHavingFilterHelper, DwQueryHelper } from "@devwareapps/devware-cap";
import { PermitsMetaData, PermitsMetaDataItemNames } from "../meta-data/permits-meta-data.service";

@DwDatasource({
    keyName: 'permitGridDataSource',
    display: 'Permit Grid Data Source',
    itemName: PermitsMetaDataItemNames.Permit,
})
@Injectable()
export class PermitGridDataSourceService extends DwOrmDataSource {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) metaDataService: DwMetaDataService,
    ) {
        super(dwOrmDataService, metaDataService, PermitsMetaDataItemNames.Permit);
    }

    prepareRequestQuery(request: DwDataRequest): DwQuery {
        const query = super.prepareRequestQuery(request);

        const permitRequestMd = PermitsMetaData.Permit;

        if (!query.Prefetch || query.Prefetch.length == 0) {
            // Add a subquery so we can apply a sort by the display value
            const subQuery = PermitsMetaData.PermitPermitType.CreateQuery();
            const qh = new DwQueryHelper();

            subQuery.FieldSettings.LoadAllLookupDisplayFields = true;
            subQuery.OrderBy("PermitTypeCvDisplay");

            query.AddPrefetchPath(permitRequestMd.Relations.PermitPermitType.RelationName, subQuery);
        }

        return query;
    }

}